/**
 * KitAddress
 * All address related utilities
 */

// See https://en.wikipedia.org/wiki/Postal_code
import addressData from '../address.json';

import { KitAddressField } from '../../components/KitAddress/KitAddress';

interface AddressOptions {
  countryCode?: string;
  data?: { [countryCode: string]: KitAddressField };
  showAddressAsString?: boolean;
}

export const addressFormatter = (options: AddressOptions = {}) => {
  const code: string = options.countryCode ? options.countryCode.toLowerCase() : '';
  const dataFormat = options.data ? options.data : addressData;
  if (code && dataFormat[code]) {
    return options.showAddressAsString && dataFormat[code].stringAddress
      ? dataFormat[code].stringAddress
      : dataFormat[code].address;
  }
  return dataFormat.default?.address || dataFormat.us?.address || [];
};

export const getEditAddressFormat = (options: AddressOptions = {}) => {
  const code: string = options.countryCode ? options.countryCode.toLowerCase() : '';
  const dataFormat = options.data ? options.data : addressData;
  if (code && dataFormat[code] && dataFormat[code].editAddress) {
    return dataFormat[code].editAddress;
  }
  return dataFormat.default?.editAddress || dataFormat.us?.editAddress || [];
};

export const checkIfHasState = (countryCode = 'us', options = {}) => {
  const format = getEditAddressFormat({ countryCode, ...options });
  return format.flat().includes('stateId');
};

export const getAddressLabelsByCountry = (field: string, options: AddressOptions = {}) => {
  const aliases = {
    zip_code: 'zipcode',
    zipCode: 'zipcode',
    stateId: 'state',
    state_id: 'state',
    country: 'country',
    countryId: 'country',
    country_id: 'country',
  };
  const labelField = aliases[field] || field;
  const code: string = options.countryCode ? options.countryCode.toLowerCase() : '';
  const dataFormat = options.data ? options.data : addressData;
  if (dataFormat[code] && dataFormat[code].labels) {
    return dataFormat[code].labels[labelField] || labelField;
  }
  return dataFormat.default?.labels[labelField] || labelField;
};
